






















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CoffeeIcon extends Vue {
  @Prop({ type: Number, default: 24 }) private readonly width!: number;
  @Prop({ type: Number, default: 24 }) private readonly height!: number;
}
